import 'css-chunksrc/client/scenes/projectExpenseEdition/form/elementAttachments/documentCard/styles.scss';export default {
  "documentCard": "_documentCard_23m4n_1",
  "isSelected": "_isSelected_23m4n_12",
  "removeButton": "_removeButton_23m4n_16",
  "documentIcon": "_documentIcon_23m4n_29",
  "documentInfo": "_documentInfo_23m4n_34",
  "top": "_top_23m4n_48",
  "bottom": "_bottom_23m4n_61",
  "hoverContainer": "_hoverContainer_23m4n_70",
  "checkbox": "_checkbox_23m4n_88",
  "lensButton": "_lensButton_23m4n_95"
};